export const API_ENDPOINTS = {
  //ADMIN
  ADMIN_LOGIN: "/login",
  USER_DELETE: "/delete",
  ADMIN_DETAIL: "/profile",
  ADMIN_SAVE: "/save-profile",
  VALIDATE_TOKEN: "/validate-token",
  ADMIN_UPDATE_PASSWORD: "/update-password",

  // FILE
  FILE_LIST: "/file/list",
  FILE_SAVE: "/file/save",
  FILE_DELETE: "/file/remove",
  FILE_UPLOAD: "/file/upload",
  FILE_DOWNLOAD: "/file/download",
  FILE_PREVIEW: "/file/preview",
  FILE_REMOVE: "/file/remove",

  //ALL PAGES
  PAGE_SAVE: "/pages/save",
  PAGE_DETAIL: "/pages/details",

  //SERVICE LIST
  SERVICE_LIST: "/service/list",
  SERVICE_SAVE: "/service/save",
  SERVICE_DELETE: "/service/delete",
  SERVICE_DETAIL: "/service/details",

  //HOMEPAGE
  HOMEPAGE_DETAIL: "/homepage/details",
  HOMEPAGE_SAVE: "/homepage/save",

  //CONTACT
  CONTACT_LIST: "/contact/list",
  CONTACT_DELETE: "/contact/delete",

  // Blogs
  BLOG_LIST: "/blog/list",
  BLOG_SAVE: "/blog/save",
  BLOG_DELETE: "/blog/delete",
  BLOG_DETAILS: "/blog/details",
  BLOG_STATUS: "/blog/toggle-status",

  // Author
  AUTHOR_LIST: "/author/list",
  AUTHOR_SAVE: "/author/save",
  AUTHOR_DELETE: "/author/delete",
  AUTHOR_DETAILS: "/author/details",
};